<template>
  <el-card>
      <el-row>
          <el-col :span="18">&nbsp;</el-col>
          <el-col :span="6">
            <el-button v-if="showAdd" type="primary" @click="addInsuranceType">添加保险类型</el-button>
            <el-button type="primary" @click="goBack">返回</el-button>
          </el-col>
      </el-row>
      <el-row>
          <el-col>
            <el-table :data="list">
                <el-table-column prop="type_name" label="险种名称"></el-table-column>
                <el-table-column prop="insurance_type_code" label="险种类型代码"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="create_time" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-tooltip v-if="showView" effect="light" placement="top-start" content="查看">
                        <el-button type="text" @click="viewInsuranceType(scope.row.id)"><i class="el-icon-view"></i></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="showEdit" effect="light" placement="top-start" content="编辑">
                        <el-button type="text" @click="editInsuranceType(scope.row.id)"><i class="el-icon-edit"></i></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="showDelete" effect="light" placement="top-start" content="删除">
                        <el-button type="text" @click="deleteInsuranceType(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="showSetCommissionRate" effect="light" placement="top-start" content="设置手续费比例">
                        <el-button type="text" @click="setCommissionRate(scope.row.id)"><i class="el-icon-money"></i></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="showSetCommissionRate2Agent" effect="light" placement="top-start" content="设置计提比例">
                        <el-button type="text" @click="setCommissionRate2Agent(scope.row.id)"><i class="el-icon-coin"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
            </el-table>
          </el-col>
      </el-row>

    <el-dialog 
      :visible.sync="dialogCommissionRateVisible"
      width="50%"
      title="设置手续费比例">
      <el-row>
          <el-col :span="18">
            <el-form ref="commissionRateDataForm" :model="commissionRateDataForm" :rules="commissionRateRules">
              <el-input v-model="commissionRateDataForm.rate" prop="rate" placeholder="请输入手续费比例"></el-input>
            </el-form>
            <el-form ref="commissionRateDataForm" :model="commissionRateDataForm" :rules="commissionRateRules">
              <el-input v-model="commissionRateDataForm.remark" prop="remark" placeholder="请输入备注"></el-input>
            </el-form>
          </el-col>
          <el-col :span="6">
              <el-button v-if="showAddCommissionRate" type="primary" @click="addCommissionRate">添加手续费比例</el-button>
          </el-col>
      </el-row>
      <el-row>
          <el-col >
            <el-table :data="commissionRateList">
                <el-table-column prop="rate" label="比列"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column label="默认值">
                  <template v-if="showDeleteCommissionRate" slot-scope="scope2">
                    <el-switch v-model="scope2.row.is_default" @change="setCommissionRateDefault(scope2.row)" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-if="showDeleteCommissionRate" slot-scope="scope2">
                  <el-button type="text" @click="deleteCommissionRate(scope2.row.id)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="18">&nbsp;</el-col>
          <el-col :span="6">
              <!-- <el-button>关闭</el-button> -->
              <!-- <el-button type="primary">保存</el-button> -->
          </el-col>
      </el-row>
    </el-dialog>

    <el-dialog 
      :visible.sync="dialogCommissionRate2AgentVisible"
      width="50%"
      title="设置佣金比例">
      <el-row>
          <el-col :span="18">
            <el-form ref="commissionRate2AgentDataForm" :model="commissionRate2AgentDataForm" :rules="commissionRate2AgentRules">
              <el-input v-model="commissionRate2AgentDataForm.rate" prop="rate" placeholder="请输入手续费比例"></el-input>
            </el-form>
            <el-form ref="commissionRate2AgentDataForm" :model="commissionRate2AgentDataForm" :rules="commissionRate2AgentRules">
              <el-input v-model="commissionRate2AgentDataForm.remark" prop="remark" placeholder="请输入备注"></el-input>
            </el-form>
          </el-col>
          <el-col :span="6">
              <el-button v-if="showAddCommissionRate2Agent" type="primary" @click="addCommissionRate2Agent">添加手续费比例</el-button>
          </el-col>
      </el-row>
      <el-row>
          <el-col >
            <el-table :data="commissionRate2AgentList">
                <el-table-column prop="rate" label="比列"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column label="默认值">
                  <template v-if="showDeleteCommissionRate2Agent" slot-scope="scope2">
                    <el-switch v-model="scope2.row.is_default" @change="setCommissionRate2AgentDefault(scope2.row)" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template  v-if="showDeleteCommissionRate2Agent" slot-scope="scope2">
                  <el-button type="text" @click="deleteCommissionRate2Agent(scope2.row.id)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="18">&nbsp;</el-col>
          <el-col :span="6">
              <!-- <el-button>关闭</el-button> -->
              <!-- <el-button type="primary">保存</el-button> -->
          </el-col>
      </el-row>
    </el-dialog>

  </el-card>    
</template>

<script>
import { fetchSettingInsuranceTypeList } from '@/api/billing'
import { deleteSettingInsuranceType } from '@/api/billing'

import { fetchSettingCommissionRateList } from '@/api/billing'
import { createSettingCommissionRate, updateSettingCommissionRate } from '@/api/billing'
import { deleteSettingCommissionRate } from '@/api/billing'

import { fetchSettingCommissionRate2AgentList } from '@/api/billing'
import { createSettingCommissionRate2Agent, updateSettingCommissionRate2Agent } from '@/api/billing'
import { deleteSettingCommissionRate2Agent } from '@/api/billing'


export default {
  name: 'setting-insurance-type-list',
  data(){
    return {
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showSetCommissionRate: false,
      showAddCommissionRate: false,
      showDeleteCommissionRate: false,
      showSetCommissionRate2Agent: false,
      showAddCommissionRate2Agent: false,
      showDeleteCommissionRate2Agent: false,
      query:{
        offset: 0,
        limit: 20
      },
      loading: false,
      list:[],

      type_id: 0,

      commissionRateList:[],
      commissionRateDataForm:{
        rate:0,
        remark:'',
      },
      commissionRateRules:{
        rate:[
          {required:true, message:"请输入比例", trigger: 'blur'}
        ]
      },
      dialogCommissionRateVisible: false,

      commissionRate2AgentList:[],
      commissionRate2AgentDataForm:{
        rate:0,
        remark:'',
      },
      commissionRate2AgentRules:{
        rate:[
          {required:true, message:"请输入比例", trigger: 'blur'}
        ]
      },
      dialogCommissionRate2AgentVisible: false,
      company_id: null,
      branch_office_id: null,
    }
  },
  methods: {
    goBack: function(){
      this.$router.go(-1)
    },
    addInsuranceType: function(){
      this.$router.push({name:'addSettingInsuranceType', query:{company_id: this.company_id, branch_office_id: this.branch_office_id}})      
    },
    viewInsuranceType: function(id){
      this.$router.push({name:'viewSettingInsuranceType', query:{company_id: this.company_id, branch_office_id: this.branch_office_id, id: id}})
    },
    editInsuranceType: function(id){
      this.$router.push({name:'editSettingInsuranceType', query:{company_id: this.company_id, branch_office_id: this.branch_office_id, id: id}})
    },
    deleteInsuranceType: function(id){
      deleteSettingInsuranceType(id)
        .then(resp=>{
          this.$message.success('删除险种信息成功')
          this.getList()
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    setCommissionRate: function(type_id){
      console.log('type_id: ' + type_id)
      this.type_id = type_id
      this.commissionRateDataForm.rate = 0
      this.dialogCommissionRateVisible = true
      this.getCommissionRateList()
    },
    setCommissionRateDefault: function(item) {
      updateSettingCommissionRate(item, item.insurance_type, item.id)
      .then(res => {
        this.$message.success('默认值设置成功')
        this.getCommissionRateList()
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    setCommissionRate2Agent: function(type_id){
      console.log('type_id: ' + type_id)
      this.type_id = type_id
      this.commissionRate2AgentDataForm.rate = 0
      this.dialogCommissionRate2AgentVisible = true
      this.getCommissionRate2AgentList()
    },
    setCommissionRate2AgentDefault: function(item) {
      updateSettingCommissionRate2Agent(item, item.insurance_type, item.id)
      .then(res => {
        this.$message.success('默认值设置成功')
        this.getCommissionRate2AgentList()
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    getList: function(){
      this.loading = true
      fetchSettingInsuranceTypeList(this.query, this. branch_office_id)
        .then(resp=>{
          this.loading = false
          this.list = resp.results
        }).catch(err=>{
          this.loading = false
          this.$error_message(err)
        })
    },

    getCommissionRateList: function(){
      fetchSettingCommissionRateList(this.query, this.type_id)
        .then(resp=>{
          this.commissionRateList = resp.results
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    addCommissionRate: function(){
      if (this.commissionRateList.length === 0) {
        this.commissionRateDataForm.is_default = true
      }
      else {
        this.commissionRateDataForm.is_default = false
      }
      this.$refs.commissionRateDataForm.validate((valid) => {
        if (valid){
          createSettingCommissionRate(this.commissionRateDataForm, this.type_id)
            .then(resp=>{
              this.$message.success('添加手续费比例成功')
              this.getCommissionRateList()
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    },
    deleteCommissionRate: function(id){
      deleteSettingCommissionRate(this.type_id, id)
        .then(resp=>{
          this.$message.success('删除手续费比例成功')
          this.getCommissionRateList()
        }).catch(err=>{
          this.$error_message(err)
        })
    },

    getCommissionRate2AgentList: function(){
      fetchSettingCommissionRate2AgentList(this.query, this.type_id)
        .then(resp=>{
          this.commissionRate2AgentList = resp.results
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    addCommissionRate2Agent: function(){
      if (this.commissionRate2AgentList.length === 0) {
        this.commissionRate2AgentDataForm.is_default = true
      }
      else {
        this.commissionRate2AgentDataForm.is_default = false
      }
      this.$refs.commissionRate2AgentDataForm.validate((valid) => {
        if (valid){
          createSettingCommissionRate2Agent(this.commissionRate2AgentDataForm, this.type_id)
            .then(resp=>{
              this.$message.success('添加手续费比例成功')
              this.getCommissionRate2AgentList()
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    },
    deleteCommissionRate2Agent: function(id){
      deleteSettingCommissionRate2Agent(this.type_id, id)
        .then(resp=>{
          this.$message.success('删除手续费比例成功')
          this.getCommissionRate2AgentList()
        }).catch(err=>{
          this.$error_message(err)
        })
    },
  },
  created(){
    if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
      console.log('missing company_id')
      this.$router.push('/404')
    }
    this.company_id = this.$route.query.company_id

    if (this.$route.query.branch_office_id === undefined || this.$route.query.branch_office_id === null){
      console.log('missing branch_office_id')
      this.$router.push('/404')
    }
    this.branch_office_id = this.$route.query.branch_office_id

    // 权限检查
    if (!this.$perm(["billing.list_setting_insurance_type"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["billing.create_setting_insurance_type"])) {
      this.showAdd = true
    }
    if (this.$perm(["billing.update_setting_insurance_type"])) {
      this.showEdit = true
    }
    if (this.$perm(["billing.delete_setting_insurance_type"])) {
      this.showDelete = true
    }

    if (this.$perm(["billing.list_setting_commission_rate"])) {
      this.showSetCommissionRate = true
    }
    if (this.$perm(["billing.create_setting_commission_rate"])) {
      this.showAddCommissionRate = true
    }
    if (this.$perm(["billing.delete_setting_commission_rate"])) {
      this.showDeleteCommissionRate = true
    }

    if (this.$perm(["billing.list_setting_commission_rate_2agent"])) {
      this.showSetCommissionRate2Agent = true
    }
    if (this.$perm(["billing.create_setting_commission_rate_2agent"])) {
      this.showAddCommissionRate2Agent = true
    }
    if (this.$perm(["billing.delete_setting_commission_rate_2agent"])) {
      this.showDeleteCommissionRate2Agent = true
    }

    this.getList()
  }
 }
</script>


<style lang="scss" scoped>
    .el-dialog .el-row {
    margin-bottom:20px;
    }
</style>